import { WizardStep } from "app/modules/shared/wizard/WizardStepViewer";
import ServiceChargeDateCodes from "./steps/ServiceChargeDateCodes/ServiceChargeDateCodes";
import DevelopmentsOrPropertyManagers from "./steps/DevelopmentsOrPropertyManagers/DevelopmentsOrPropertyManagers";
import GraceDays from "./steps/GraceDays/GraceDays";
import { DevelopmentChargePreList } from "./steps/DevelopmentChargesPreList/DevelopmentChargePreList";
import InvoicesPreview from "./steps/InvoicePreview/InvoicesPreview";
import InvoiceSending from "./steps/InvoiceSending/InvoiceSending";

export enum ServiceChargeInvoicingSteps {
  ServiceChargeDateCodes = 1,
  DevelopmentsOrPropertyManagers = 2,
  GraceDays = 3,
  DevelopmentChargesPreList = 4,
  GenerateInvoices = 5,
  SendInvoices = 6,
}

export const ServiceChargeInvoicingWizardMapping: WizardStep[] = [
  {
    StepNumber: ServiceChargeInvoicingSteps.ServiceChargeDateCodes,
    StepComponent: <ServiceChargeDateCodes />,
  },
  {
    StepNumber: ServiceChargeInvoicingSteps.DevelopmentsOrPropertyManagers,
    StepComponent: <DevelopmentsOrPropertyManagers />,
  },
  {
    StepNumber: ServiceChargeInvoicingSteps.GraceDays,
    StepComponent: <GraceDays />,
  },
  {
    StepNumber: ServiceChargeInvoicingSteps.DevelopmentChargesPreList,
    StepComponent: <DevelopmentChargePreList />,
  },
  {
    StepNumber: ServiceChargeInvoicingSteps.GenerateInvoices,
    StepComponent: <InvoicesPreview />,
  },
  {
    StepNumber: ServiceChargeInvoicingSteps.SendInvoices,
    StepComponent: <InvoiceSending />,
  },
];
